<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.showJobApplication") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badges ==== -->
      <div class="badges_wrapper justify-content-end">
        <v-chip
          :color="getStatusColor(data.status_enum)"
          text-color="white"
          large
        >
          {{ data.status }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badges ==== -->

      <!-- ==== Start:: Main Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Applicant Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.applicantName')"
            v-model.trim="data.client_name"
            disabled
          />
          <!-- End:: Applicant Name Input -->

          <!-- Start:: Job Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.jobName')"
            v-model.trim="data.job_name"
            disabled
          />
          <!-- End:: Job Name Input -->

          <!-- Start:: Phone Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.mobile"
            disabled
          />
          <!-- End:: Phone Input -->

          <!-- Start:: ID Number Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.idNumber')"
            v-model.trim="data.identity_number"
            disabled
          />
          <!-- End:: ID Number Input -->

          <!-- Start:: Birth Date Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.birthDate')"
            v-model="data.birth_date"
            disabled
          />
          <!-- End:: Birth Date Input -->

          <!-- Start:: Age Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.employeeAge')"
            v-model.trim="data.age"
            disabled
          />
          <!-- End:: Age Input -->

          <!-- Start:: Identity Image -->
          <div class="col-12 mb-3">
            <label class="form-label">{{
              $t("PLACEHOLDERS.identityImage")
            }}</label>
            <div
              v-if="data.identity_image"
              class="image_preview"
              @click="openImageModal(data.identity_image)"
            >
              <img :src="data.identity_image" alt="Identity Image" />
            </div>
            <p v-else class="text-muted">{{ $t("TABLES.noData") }}</p>
          </div>
          <!-- End:: Identity Image -->

          <!-- Start:: CV File -->
          <div class="col-12 mb-3">
            <label class="form-label">{{ $t("PLACEHOLDERS.cvFile") }}</label>
            <div v-if="data.cv">
              <a :href="data.cv" target="_blank" class="custom_btn primary_btn">
                <i class="fal fa-file-pdf"></i>
                {{ $t("PLACEHOLDERS.viewCV") }}
              </a>
            </div>
            <p v-else class="text-muted">{{ $t("TABLES.noData") }}</p>
          </div>
          <!-- End:: CV File -->

          <!-- Start:: Contract File (if accepted) -->
          <div class="col-12 mb-3" v-if="data.contract_file">
            <label class="form-label">{{
              $t("PLACEHOLDERS.contractFile")
            }}</label>
            <div>
              <a
                :href="data.contract_file"
                target="_blank"
                class="custom_btn info_btn"
              >
                <i class="fal fa-file-contract"></i>
                {{ $t("PLACEHOLDERS.viewContract") }}
              </a>
            </div>
          </div>
          <!-- End:: Contract File -->

          <!-- Start:: Salary (if accepted) -->
          <base-input
            v-if="data.salary"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.salary')"
            v-model.trim="data.salary"
            disabled
          />
          <!-- End:: Salary -->

          <!-- Start:: Rejection Reason (if rejected) -->
          <base-input
            v-if="data.rejection_reason"
            col="12"
            type="textarea"
            rows="3"
            :placeholder="$t('PLACEHOLDERS.rejectionReason')"
            v-model.trim="data.rejection_reason"
            disabled
          />
          <!-- End:: Rejection Reason -->

          <!-- Start:: Application Date Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.applicationDate')"
            v-model="data.created_at"
            disabled
          />
          <!-- End:: Application Date Input -->

          <!-- Start:: Action Buttons (Only for pending status) -->
          <!-- <div
            class="col-12 mt-4"
            v-if="
              data.status_enum === 'pending' &&
              $can('job applications changestatus', 'job_applications')
            "
          >
            <div class="d-flex justify-content-center gap-3">
              <base-button
                styleType="success_btn"
                :btnText="$t('BUTTONS.accept')"
                @fireClick="openAcceptModal"
              />
              <base-button
                styleType="danger_btn"
                :btnText="$t('BUTTONS.reject')"
                @fireClick="openRejectModal"
              />
            </div>
          </div> -->
          <!-- End:: Action Buttons -->
        </div>
      </form>
      <!-- ==== End:: Main Data ==== -->
    </div>
    <!-- END:: Single Step Form Content -->

    <!-- Start:: Accept Modal -->
    <v-dialog v-model="acceptModalIsOpen" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("TITLES.acceptApplicationConfirm") }}
        </v-card-title>

        <v-card-text>
          <form @submit.prevent="handleAccept">
            <div class="row">
              <!-- Start:: Contract File Upload -->
              <base-name-preview-file-upload-input
                col="12"
                identifier="contract_file"
                :placeholder="$t('PLACEHOLDERS.uploadContract')"
                accept=".pdf"
                @selectFile="selectContractFile"
                required
              />
              <!-- End:: Contract File Upload -->

              <!-- Start:: Salary Input -->
              <base-input
                col="12"
                type="number"
                :placeholder="$t('PLACEHOLDERS.salary')"
                v-model.trim="acceptFormData.salary"
              />
              <!-- End:: Salary Input -->
            </div>
          </form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            class="modal_confirm_btn"
            @click="handleAccept"
            :disabled="!acceptFormData.contract_file || isWaitingRequest"
          >
            {{ $t("BUTTONS.save") }}
          </v-btn>

          <v-btn
            class="modal_cancel_btn"
            @click="acceptModalIsOpen = false"
            :disabled="isWaitingRequest"
          >
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Accept Modal -->

    <!-- Start:: Reject Modal -->
    <v-dialog v-model="rejectModalIsOpen" max-width="600px" persistent>
      <v-card>
        <v-card-title class="text-h5 justify-center">
          {{ $t("TITLES.rejectApplicationConfirm") }}
        </v-card-title>

        <v-card-text>
          <form @submit.prevent="handleReject">
            <div class="row">
              <!-- Start:: Rejection Reason Input -->
              <base-input
                col="12"
                type="textarea"
                rows="4"
                :placeholder="$t('PLACEHOLDERS.rejectionReason')"
                v-model.trim="rejectFormData.rejection_reason"
                required
              />
              <!-- End:: Rejection Reason Input -->
            </div>
          </form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            class="modal_confirm_btn"
            @click="handleReject"
            :disabled="
              !rejectFormData.rejection_reason ||
              rejectFormData.rejection_reason.length < 10 ||
              isWaitingRequest
            "
          >
            {{ $t("BUTTONS.send") }}
          </v-btn>

          <v-btn
            class="modal_cancel_btn"
            @click="rejectModalIsOpen = false"
            :disabled="isWaitingRequest"
          >
            {{ $t("BUTTONS.cancel") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Reject Modal -->

    <!-- Start:: Image Modal -->
    <v-dialog v-model="imageModalIsOpen" max-width="800px">
      <v-card>
        <v-card-text>
          <img :src="selectedImage" class="w-100" alt="Preview" />
        </v-card-text>
        <v-card-actions>
          <v-btn class="modal_cancel_btn" @click="imageModalIsOpen = false">
            {{ $t("BUTTONS.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End:: Image Modal -->
  </div>
</template>

<script>
import BaseNamePreviewFileUploadInput from "@/components/formInputs/BaseNamePreviewFileUploadInput.vue";

export default {
  name: "ShowJobApplication",
  components: {
    BaseNamePreviewFileUploadInput,
  },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data
      data: {
        id: null,
        client_name: null,
        job_name: null,
        mobile: null,
        identity_number: null,
        birth_date: null,
        age: null,
        identity_image: null,
        cv: null,
        contract_file: null,
        salary: null,
        rejection_reason: null,
        created_at: null,
        status_enum: null,
        status: null,
      },
      // End:: Data

      // Start:: Accept Modal Data
      acceptModalIsOpen: false,
      acceptFormData: {
        contract_file: null,
        salary: null,
      },
      // End:: Accept Modal Data

      // Start:: Reject Modal Data
      rejectModalIsOpen: false,
      rejectFormData: {
        rejection_reason: null,
      },
      // End:: Reject Modal Data

      // Start:: Image Modal Data
      imageModalIsOpen: false,
      selectedImage: null,
      // End:: Image Modal Data
    };
  },

  methods: {
    // Start:: Get Status Color
    getStatusColor(statusEnum) {
      switch (statusEnum) {
        case "pending":
          return "orange";
        case "accepted":
          return "green";
        case "rejected":
          return "red";
        default:
          return "grey";
      }
    },
    // End:: Get Status Color

    // Start:: Get Job Application Data
    async getJobApplicationData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `job-applications/${this.$route.params.id}`,
        });
        const applicationData = res.data.data.data;

        this.data.id = applicationData.id;
        this.data.client_name = applicationData.client?.name;
        this.data.job_name = applicationData.job?.name;
        this.data.mobile = applicationData.client?.mobile;
        this.data.identity_number = applicationData.identity_number;
        this.data.birth_date = applicationData.birth_date;
        this.data.age = applicationData.age;
        this.data.identity_image = applicationData.identity_image;
        this.data.cv = applicationData.cv;
        this.data.contract_file = applicationData.contract_file;
        this.data.salary = applicationData.salary;
        this.data.rejection_reason = applicationData.rejection_reason;
        this.data.created_at = applicationData.created_at;
        this.data.status_enum = applicationData.status_enum;
        this.data.status = applicationData.status;
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(this.$t("MESSAGES.errorLoadingData"));
      }
    },
    // End:: Get Job Application Data

    // Start:: Open Accept Modal
    openAcceptModal() {
      this.acceptModalIsOpen = true;
    },
    // End:: Open Accept Modal

    // Start:: Open Reject Modal
    openRejectModal() {
      this.rejectModalIsOpen = true;
    },
    // End:: Open Reject Modal

    // Start:: Select Contract File
    selectContractFile(selectedFile) {
      this.acceptFormData.contract_file = selectedFile.file;
    },
    // End:: Select Contract File

    // Start:: Handle Accept
    async handleAccept() {
      if (!this.acceptFormData.contract_file) {
        this.$message.error(this.$t("MESSAGES.contractFileRequired"));
        return;
      }

      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("status", "accepted");
      REQUEST_DATA.append("contract_file", this.acceptFormData.contract_file);

      if (this.acceptFormData.salary) {
        REQUEST_DATA.append("salary", this.acceptFormData.salary);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `job-applications/change-status/${this.data.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.acceptModalIsOpen = false;
        this.$message.success(this.$t("MESSAGES.applicationAccepted"));
        this.$router.push({ path: "/job-applications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Handle Accept

    // Start:: Handle Reject
    async handleReject() {
      if (
        !this.rejectFormData.rejection_reason ||
        this.rejectFormData.rejection_reason.length < 10
      ) {
        this.$message.error(this.$t("MESSAGES.rejectionReasonRequired"));
        return;
      }

      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();

      REQUEST_DATA.append("status", "rejected");
      REQUEST_DATA.append(
        "rejection_reason",
        this.rejectFormData.rejection_reason
      );

      try {
        await this.$axios({
          method: "POST",
          url: `job-applications/change-status/${this.data.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.rejectModalIsOpen = false;
        this.$message.success(this.$t("MESSAGES.applicationRejected"));
        this.$router.push({ path: "/job-applications/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },
    // End:: Handle Reject

    // Start:: Open Image Modal
    openImageModal(imageUrl) {
      this.selectedImage = imageUrl;
      this.imageModalIsOpen = true;
    },
    // End:: Open Image Modal
  },

  async created() {
    await this.getJobApplicationData();
  },
};
</script>

<style scoped>
.image_preview {
  cursor: pointer;
  max-width: 300px;
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  transition: all 0.3s ease;
}

.image_preview:hover {
  border-color: #26a1d6;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.image_preview img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.gap-3 {
  gap: 15px;
}

.custom_btn {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.3s ease;
  color: white;
}

.primary_btn {
  background-color: #26a1d6;
}

.primary_btn:hover {
  background-color: #1e8ab8;
  color: white;
}

.info_btn {
  background-color: #17a2b8;
}

.info_btn:hover {
  background-color: #138496;
  color: white;
}
</style>
